import { useTranslation } from "react-i18next";
import usePageMeta from "../hooks/usePageMeta";
import Footer from "../components/Footer";
import ContactCTA from "../components/ContactCTA";
import WhyChooseUs from "../components/WhyChooseUs";
import PartnersSection from "../components/PartnersSection";
import CustomersSection from "../components/CustomersSection";
import { Eye, Target } from "lucide-react";

export default function About() {
  const { t } = useTranslation();
  usePageMeta({
    title: "About Us | Sky Global",
    description: t("about.description"),
    path: "/about",
  });

  return (
    <>
      {/* Header */}
      <section className="relative overflow-hidden page-header pt-40 tablet:pt-36 mobile:pt-32 pb-20 tablet:pb-16 px-6 mobile:px-4">
        <div
          className="absolute inset-0 bg-grid [mask-image:radial-gradient(ellipse_at_center,#000_25%,transparent_70%)]"
          aria-hidden="true"
        ></div>
        <div className="relative container-page">
          <span className="kicker mb-4 animate-fade-in">{t("about.label")}</span>
          <h1 className="text-5xl tablet:text-4xl mobile:text-3xl font-semibold tracking-[-0.02em] text-black leading-[1.05] max-w-3xl animate-slide-up">
            {t("about.title")}
          </h1>
        </div>
      </section>

      {/* About Content */}
      <section className="py-24 tablet:py-20 px-6 mobile:px-4 bg-white">
        <div className="container-page">
          <div className="grid grid-cols-2 tablet:grid-cols-1 gap-14 tablet:gap-10">
            {/* Description */}
            <div className="space-y-6">
              <p className="text-lg tablet:text-base text-gray-600 leading-relaxed max-w-[65ch]">
                {t("about.description")}
              </p>
              <p className="text-base text-gray-600 leading-relaxed max-w-[65ch]">
                {t("about.description2")}
              </p>
            </div>

            {/* Mission & Vision */}
            <div className="space-y-5">
              <div className="rounded-xl border border-blueLight bg-blueLight p-7 transition-[box-shadow,transform] duration-300 hover:shadow-lg hover:-translate-y-1">
                <div className="flex items-center gap-3 mb-3">
                  <span className="w-9 h-9 rounded-lg bg-white flex items-center justify-center shrink-0">
                    <Eye className="w-4 h-4 text-textBlue" aria-hidden="true" />
                  </span>
                  <h2 className="text-xl font-semibold text-textBlue">{t("about.vision")}</h2>
                </div>
                <p className="text-gray-700 leading-relaxed">{t("about.visionText")}</p>
              </div>

              <div className="rounded-xl border border-backgroundTeal bg-backgroundTeal p-7 transition-[box-shadow,transform] duration-300 hover:shadow-lg hover:-translate-y-1">
                <div className="flex items-center gap-3 mb-3">
                  <span className="w-9 h-9 rounded-lg bg-white flex items-center justify-center shrink-0">
                    <Target className="w-4 h-4 text-textBlue" aria-hidden="true" />
                  </span>
                  <h2 className="text-xl font-semibold text-textBlue">{t("about.mission")}</h2>
                </div>
                <p className="text-gray-700 leading-relaxed">{t("about.missionText")}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <WhyChooseUs />
      <PartnersSection />
      <CustomersSection />
      <ContactCTA />
      <Footer />
    </>
  );
}
